import { renderExpenseCards } from "./expenses.mjs";
import { renderSettlement } from "./settlement.mjs";

/**
 * Renders the group's background view: expense list, settlement, and share section.
 * This function has NO opinion about modals — modal lifecycle is managed exclusively
 * by the Route Handler (main.mjs / route()).
 *
 * @param {Group} group
 * @return {Promise<void>}
 */
export async function renderGroup(group) {
    let el = document.getElementById('app-container');

    if (group === null) {
        el.innerHTML = `<div></div>`;
        return;
    }

    // Clear and render base group view (Expenses List & Settlement)
    el.innerHTML = '';

    const expensesContainer = document.createElement('div');
    el.appendChild(expensesContainer);
    renderExpenseCards(expensesContainer, group);

    const settlementContainer = document.createElement('div');
    el.appendChild(settlementContainer);
    renderSettlement(settlementContainer, group);

    // Add QR code and share section below settlement
    const { renderShareSection } = await import('./ui.mjs');
    await renderShareSection(el, group.id);
}